"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var textInputLocal = function textInputLocal(theme) {
  return {
    state: {
      success: {
        color: theme.color.monochrome5["default"],
        backgroundColor: theme.color.monochrome1["default"],
        border: {
          color: theme.color.success["default"],
          width: theme.border.width[2]
        }
      },
      info: {
        color: theme.color.monochrome5["default"],
        backgroundColor: theme.color.monochrome1["default"],
        border: {
          color: theme.color.info["default"],
          width: theme.border.width[2]
        }
      },
      warn: {
        color: theme.color.monochrome5["default"],
        backgroundColor: theme.color.monochrome1["default"],
        border: {
          color: theme.color.warn["default"],
          width: theme.border.width[2]
        }
      },
      error: {
        color: theme.color.monochrome5["default"],
        backgroundColor: theme.color.monochrome1["default"],
        border: {
          color: theme.color.error["default"],
          width: theme.border.width[2]
        }
      },
      disabled: {
        color: theme.color.monochrome5.disabled,
        backgroundColor: theme.color.monochrome2["default"],
        border: {
          color: theme.color.monochrome5.disabled,
          width: theme.border.width[1]
        }
      }
    }
  };
};

var _default = textInputLocal;
exports["default"] = _default;
//# sourceMappingURL=TextInput.theme.js.map